import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { IUpdateGoalQueueRequest } from "./request.types";
import { TGetGoalListResponse, TGoalStatus } from "./response.types";

class GoalsController extends Controller {
	public constructor() {
		super({ requestUrl: "models/goal" });
	}

	/** @GET GOAL LIST */
	public async getGoalListAsync({ token, statuses }: IRequestConfig & { statuses?: TGoalStatus[] }) {
		return this.get<TGetGoalListResponse>("base", "/list", { token, params: { statuses } });
	}

	/** @PATCH UPDATE GOAL QUEUE */
	public async updateGoalQueueAsync({ token, data }: IUpdateGoalQueueRequest) {
		return this.patch<void>("/queue", { goals: data }, { token });
	}

	/** @DELETE DELETE GOAL BY ID */
	public async deleteGoalByIdAsync({ token, goalId }: IRequestConfig & { goalId: string }) {
		return this.delete<void>(`/${goalId}`, { token });
	}

	/** @POST START GOAL */
	public async startGoalAsync({ token }: IRequestConfig) {
		return this.post<void>("/start", null, { token });
	}
}

export const goalsAPI = new GoalsController();
